import React from "react";
import Controls from "src/components/form/controls/Controls";

const iconTypeOption = [
  {
    id: "device",
    name: "Device",
  },
  {
    id: "group_device",
    name: "Group Device",
  },
  {
    id: "context",
    name: "Context",
  },
  {
    id: "vms",
    name: "VMS",
  },
  {
    id: "icon",
    name: "Icon",
  },
];

const IconPanelOptional = ({ iconType, onChange }) => {
  return (
    <div style={{ display: "flex" }}>
      <Controls.Select
        name="iconType"
        label="Icon Type"
        value={iconType}
        onChange={(e) => onChange(e.target.value)}
        options={iconTypeOption}
        style={{ width: "150px" }}
      />
    </div>
  );
};

export default IconPanelOptional;
